import React, { useEffect, useState } from 'react';
import './HomeSidebar.css';

const SECTIONS = [
  { id: 'work', label: 'Work' },
  { id: 'art', label: 'Art' },
  { id: 'about', label: 'About Me' },
];

const LINKS = [
  { label: 'Email', href: 'mailto:mixinyi@cca.edu' },
  { label: 'LinkedIn', href: 'https://www.linkedin.com/in/angelhagen/' },
  { label: 'Instagram', href: 'https://www.instagram.com/buildwithyaya/' },
  { label: 'X', href: 'https://x.com/buildwithyaya' },
  {
    label: 'Resume',
    href: 'https://drive.google.com/file/d/1a_YYEtun0_GbC5lzc7FX5CaIe7k5Fsr9/view?usp=sharing',
  },
];

const pad = (n) => `${String(n).padStart(2, '0')}.`;

function Arrow({ external }) {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {external ? (
        <path d="M5 11 11 5M6 5h5v5" />
      ) : (
        <path d="M3 8h10M9 4l4 4-4 4" />
      )}
    </svg>
  );
}

export default function HomeSidebar({ activeTab, setActiveTab }) {
  if (activeTab === 'about') {
    return (
      <aside className="home-sidebar" aria-label="Navigation">
        <button type="button" className="home-sidebar-back" onClick={() => setActiveTab('work')}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M13 8H3M7 4 3 8l4 4" />
          </svg>
          Back home
        </button>
      </aside>
    );
  }

  return (
    <aside className="home-sidebar" aria-label="Introduction and navigation">
      <div className="home-sidebar-brand">
        <h1 className="home-sidebar-name">Yaya Hagen</h1>
        <p className="home-sidebar-role">Product designer who ships 0→1</p>
        <p className="home-sidebar-bio">
          Yaya Hagen is a product designer with a hospitality heart and a habit
          of shipping. Drawn to 0→1 products and the small moments where people
          hesitate, need help, or feel cared for, Yaya designs technology that
          feels more thoughtful and human.
        </p>
        <p className="home-sidebar-bio">
          Currently designing <strong>@Spira.AI</strong>. Previously{' '}
          <strong>@ZOVU</strong> and <strong>@Omnigence.ai</strong>. Campus
          Leader <strong>@Adobe</strong>.
        </p>
      </div>

      <nav className="home-sidebar-group" aria-label="Sections">
        <p className="home-sidebar-label">Sections</p>
        {SECTIONS.map((item, i) => (
          <button
            key={item.id}
            type="button"
            className={`home-sidebar-link${activeTab === item.id ? ' home-sidebar-link--active' : ''}`}
            aria-current={activeTab === item.id ? 'page' : undefined}
            onClick={() => setActiveTab(item.id)}
          >
            <span className="home-sidebar-num">{pad(i + 1)}</span>
            <span>{item.label}</span>
            <span className="home-sidebar-arr"><Arrow /></span>
          </button>
        ))}
      </nav>

      <nav className="home-sidebar-group" aria-label="Links">
        <p className="home-sidebar-label">Links</p>
        {LINKS.map((item, i) => (
          <a
            key={item.label}
            className="home-sidebar-link"
            href={item.href}
            {...(item.href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
          >
            <span className="home-sidebar-num">{pad(SECTIONS.length + i + 1)}</span>
            <span>{item.label}</span>
            <span className="home-sidebar-arr"><Arrow external /></span>
          </a>
        ))}
      </nav>

      <p className="home-sidebar-credit">©2026 Designed and coded by Yaya!</p>
    </aside>
  );
}

const formatSF = () =>
  new Date().toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'America/Los_Angeles',
  });

export function HomeTopBar() {
  const [time, setTime] = useState(formatSF);

  useEffect(() => {
    const id = setInterval(() => setTime(formatSF()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <header className="home-topbar">
      <p className="home-clock">San Francisco, {time}</p>
    </header>
  );
}
